import { Box, Stack, Tab, Tabs } from '@mui/material';
import { INVOICE_TYPE_CLIENT, INVOICE_TYPE_SUPPLIER, InvoiceDto } from '@sr/dto';
import { CopyInvoiceButton } from 'features/invoice/copy-invoice-button/copy-invoice-button';
import { Link } from 'react-router-dom';
import { invoiceLinkManager } from 'utils/link-manager';
import { PrintInvoiceButton } from 'widgets/invoice/print-form';

type InvoiceMode = 'edit' | 'report';

type Props = {
  invoice: Pick<InvoiceDto, 'id' | 'type' | 'seller'>;
  mode: InvoiceMode;
};

export const InvoiceModeActions = ({ invoice, mode }: Props) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-end" flexWrap="wrap" useFlexGap>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={mode}
          aria-label="Режим счета"
          sx={{
            minHeight: 36,
            '& .MuiTabs-indicator': {
              height: 3
            },
            '& .MuiTab-root': {
              fontSize: '0.95rem',
              fontWeight: 500,
              minHeight: 36,
              px: 2,
              py: 0.75,
              textTransform: 'none',
              whiteSpace: 'nowrap'
            }
          }}
        >
          <Tab label="Редактирование" value="edit" to={invoiceLinkManager.link(invoice.id)} component={Link} />
          <Tab label="Отчет" value="report" to={invoiceLinkManager.reportLink(invoice.id)} component={Link} />
        </Tabs>
      </Box>

      {(invoice.type === INVOICE_TYPE_CLIENT || invoice.type === INVOICE_TYPE_SUPPLIER) &&
        <CopyInvoiceButton invoiceId={invoice.id} invoiceType={invoice.type} sellerLegalEntityId={invoice.seller?.id} />}

      <PrintInvoiceButton allowPrintWithStamp={invoice.type === INVOICE_TYPE_CLIENT} invoiceId={invoice.id} />
    </Stack>
  );
};
